var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BasePlugin from './base';
// TODO: Add more methods specific to this plugin
var DefaultPageViewPlugin = /** @class */ (function (_super) {
    __extends(DefaultPageViewPlugin, _super);
    function DefaultPageViewPlugin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultPageViewPlugin.prototype.init = function (config) {
        _super.prototype.init.call(this, config);
    };
    DefaultPageViewPlugin.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    DefaultPageViewPlugin.prototype.handleDefaultPageView = function () {
        throw new Error('Method not implemented.');
    };
    return DefaultPageViewPlugin;
}(BasePlugin));
export default DefaultPageViewPlugin;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1wYWdlLXZpZXctcGx1Z2luLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3BsdWdpbnMvZGVmYXVsdC1wYWdlLXZpZXctcGx1Z2luLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBLE9BQU8sVUFBVSxNQUFNLFFBQVEsQ0FBQztBQUloQyxpREFBaUQ7QUFDakQ7SUFBbUYseUNBQWE7SUFBaEc7O0lBWUEsQ0FBQztJQVhDLG9DQUFJLEdBQUosVUFBSyxNQUFVO1FBQ2IsaUJBQU0sSUFBSSxZQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3JCLENBQUM7SUFFRCx1Q0FBTyxHQUFQO1FBQ0UsaUJBQU0sT0FBTyxXQUFFLENBQUM7SUFDbEIsQ0FBQztJQUVELHFEQUFxQixHQUFyQjtRQUNFLE1BQU0sSUFBSSxLQUFLLENBQUMseUJBQXlCLENBQUMsQ0FBQztJQUM3QyxDQUFDO0lBQ0gsNEJBQUM7QUFBRCxDQUFDLEFBWkQsQ0FBbUYsVUFBVSxHQVk1RjtBQUVELGVBQWUscUJBQXFCLENBQUMifQ==